import {IssueCommentEditsContextProvider} from '@github-ui/commenting'
import {ItemPickersContextProvider} from '@github-ui/item-picker'
import type {ReactNode} from 'react'

import {InputElementActiveContextProvider} from './InputElementActiveContext'
import {IssueNavigationContextProvider} from './IssueNavigationContext'
import {IssueViewerDataContextProvider} from './IssueViewerDataContext'

type IssueViewerContextProviderType = {
  children: ReactNode
}

export function IssueViewerContextProvider({children}: IssueViewerContextProviderType) {
  return (
    <IssueViewerDataContextProvider>
      <ItemPickersContextProvider>
        <IssueNavigationContextProvider>
          <IssueCommentEditsContextProvider>
            <InputElementActiveContextProvider>{children}</InputElementActiveContextProvider>
          </IssueCommentEditsContextProvider>
        </IssueNavigationContextProvider>
      </ItemPickersContextProvider>
    </IssueViewerDataContextProvider>
  )
}

try{ IssueViewerContextProvider.displayName ||= 'IssueViewerContextProvider' } catch {}